
  <div class="modal-content errorDialogZ">
    <div class="modal-header errorDialogZ">
      <h4 class="modal-title pull-left text-success">{{data?.title|translate}}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="isShowCircle; else showHtml"></div>
      <ng-template #showHtml>
        <p class="body m-b-20 text-master " innerHTML="{{termsHtml}}"></p>
      </ng-template>


    </div>
    <div class="modal-footer">

      <!--<button *ngIf="data?.btCancel" type="button" class="btn btn-default" (click)="cancel()" >{{"561W"|translate}}</button>-->
      <button type="button " class="btn btn-success" (click)="clickOk()" >ok</button>
    </div>
  </div>


